import appStrings from '@/app/utility/string.utility';
import commonModal from './commonModal';
import { ModelSelect, BasicSelect } from 'vue-search-select';
import sendForApproval from '@/app/components/onlineApproval/internalWorkFlow/history/sendForApproval';
import ApprovalHistory from '@/app/components/onlineApproval/internalWorkFlow/history/approvalHistory';
import party from '../../../partyDetail';
export default {
  name: 'BusinessUnit',
  watch: {
    selectAllCheckBox: function() {
      this.checkUncheckAll();
    }
  },
  components: {
    commonModal,
    ModelSelect,
    BasicSelect,
    ApprovalHistory,
    sendForApproval,
    party
  },
  props: [ 'rowData', 'wfBUDetails', 'workflowId'
  ],
  data() {
    return {
      loader: false,
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      editMode: false,
      mapBUData: [
        {
            bu_name: null,
            expense_type: null,
            active: true,
            add_site_bu_id: null,
            nature_of_supply: null,
            tds_section: null
        }
      ],
      mapBUFields: [
        // {
        //   key: 'acc_flag',
        //   label: 'Select',
        //   variant: 'info',
        //   stickyColumn: true
        // },
        // {
        //   key: 'ou_name',
        //   label: 'Operating Unit'
        // },
        // {
        //   key: 'select',
        //   variant: 'info',
        //   stickyColumn: true
        // },
        {
          key: 'details'
        },
        {
          key: 'approval_status',
          label: 'Final Status'
        },
        {
          key: 'approval_status_key',
          label: 'Approval Status'
        },
        {
          key: 'vendor_name'
        },
        {
          key: 'bu_name',
          label: 'Business Name'
        },
        // {
        //   key: 'expense_type'
        // },
        // {
        //   key: 'nature_of_supply'
        // },
        // {
        //   key: 'tds_section'
        // },
        {
          key: 'active',
          stickyColumn: true
        },
      ],
      selectAllCheckBox: false,
      partyReqId: null,
      paymentTermsData: [],
      paymentTermsFields: [
        {
          key: 'payment_term_name',
          label: 'Transaction Name'
        },
        {
          key: 'payment_term_desc'
        }
      ],
      showCommonModal: false,
      modalType: null,
      businessList: [],
      expenseList: [],
      showHistoryBtn: false,
      historyType: null,
      selectedBUDetails: null,
      showHistory: false,
      showOpenKmModal: false,
      openkmAuthToken: null,
      showApproveRejectModal: false,
      approvRejectType: null,
      approvalReason: 'Accepted',
      rejectedReason: null,
      approvalRemarks: null,
      rejectionRemarks: null,
      urlSummaryData: null,
      wfApprovalStatus: null,
      approvalStatusKey: null,
      addSiteId: 0,
      showPartyDetailsModal: false,
      userId: this.$store.state.auth.userId,
      eventId: null,
      menuId: null,
      dataobj: {},
      showValueSetModal: false,
      valueData:null
    };
  },
  mounted() {
    this.updateKey()
    if(this.rowData){
      this.eventId = this.workflowId.eventId;
      this.menuId = this.workflowId.menuId;
      this.mapBUFields.splice(0, 0, { 
          key: 'select',
          variant: 'info',
          stickyColumn: true
         });
         
      // this.mapBUFields.splice(10, 0, { 
      //   key: 'add',
      //   stickyColumn: true
      //  })
      // this.mapBUFields.splice(11, 0, { 
      //   key: 'remove',
      //   stickyColumn: true
      //  })
        this.addSiteId = this.rowData.add_site_id;
        this.getMapBUDataById();
        this.getBusinessUnitDetail();
        // this.getExpenseTypeDetail();
    }
    // else {
    //   this.editMode = true;
    // }
        
    if (this.$route.params.summaryData) {
      this.urlSummaryData = JSON.parse(
        Buffer.from(this.$route.params.summaryData, 'base64').toString('ascii')
      );
    }
    else if (this.urlSummaryData) {
      // from link
      this.addSiteId = this.urlSummaryData.add_site_id;
      this.getMapBUDataById();
      this.getBusinessUnitDetail();
      // this.getExpenseTypeDetail();
    }
   else  if (this.wfBUDetails) {
      // from dashboard
      this.addSiteId = this.wfBUDetails.add_site_id;
      this.eventId = this.wfBUDetails.wf_event_id;
      this.menuId = this.wfBUDetails.wf_menu_id;
      this.dataobj={
        req_id:this.wfBUDetails.party_req_id
      }
      this.getMapBUDataById();
      this.getBusinessUnitDetail();
      // this.getExpenseTypeDetail();
    }
    else{
      this.eventId = this.workflowId.eventId;
      this.menuId = this.workflowId.menuId;
    }
  },
  methods: {
    showHideApproveRejectModal(flag, type) {
      this.showApproveRejectModal = flag;
      this.approvRejectType = type;
    },
    approveRejectProvisons(status) {
      const payload = {
        event_id: this.selectedBUDetails ? this.selectedBUDetails.wf_event_id : this.wfBUDetails ? this.wfBUDetails.wf_event_id : null,
        wf_inprocess_dtl_id: this.selectedBUDetails ? this.selectedBUDetails.wf_inprocess_dtl_id : this.wfBUDetails ? this.wfBUDetails.wf_inprocess_dtl_id : null,
        notification_status: status,
        notification_comments:
          status === 'REJECTED' ? this.rejectedReason : this.approvalReason
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/approvalRejectSingle', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            // this.getVendorInvoiceDetailsById();
            this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            if (status === 'REJECTED') {
              this.showHideApproveRejectModal(false);
            } else if (status === 'APPROVED') {
              this.showHideApproveRejectModal(false);
            }
            this.getMapBUDataById();
            // this.$emit('updateInvoice');
          } else {
            this.showAlert = false;
            alert(response.response.data.message);
            // this.isSuccess = false;
            // this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    selectedProvision(item) {
      this.selectedBUDetails = Object.assign({}, item);
      this.showHistoryBtn = true;
    },
    showHideHistory(flag, historyType) {
      this.showHistory = flag;
      this.historyType = historyType;
      if(!flag){
        this.getMapBUDataById();
      }
    },
    validateUploadDocument() {
      // if (this.selectedBUDetails.approval_status === 'DRAFT') {
      //   this.isDocumentUploadedFunc();
      // } else {
        this.showHideHistory(true, 'sendForApproval');
      // }
    },
    // checkOpenKmPasswordSaved() {
    //   this.loader = true;
    //   this.$store
    //     .dispatch('intWorkflow/checkSavedPassword')
    //     .then(response => {
    //       this.loader = false;
    //       if (response.status === 200) {
    //         if (response.data.data) {
    //           this.getOpenKmAuthToken();
    //         } else {
    //           this.showHideOpenKmModal(true);
    //         }
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    // getOpenKmAuthToken() {
    //   const payload = {
    //     password: null,
    //     saved_password_flag: true,
    //     user_name: null
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch('intWorkflow/openKmAuthenticate', payload)
    //     .then(response => {
    //       this.loader = false;
    //       if (response.status === 200) {
    //         this.openkmAuthToken = response.data.data.token;
    //         // this.selectedGridData = {
    //         //   ...this.selectedBUDetails,
    //         //   nfa_cat_vset: null,
    //         //   nfa_cat: null,
    //         //   nfa_sub_cat_vset: null,
    //         //   nfa_sub_cat: null
    //         // };
    //         // this.showHideHistory(true, 'uploadDocument');
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    // showHideOpenKmModal(flag) {
    //   this.showOpenKmModal = flag;
    // },
    // setOpenKmToken(token) {
    //   this.showHideOpenKmModal(false);
    //   this.openkmAuthToken = token;
    //   // this.selectedGridData = {
    //   //   ...this.selectedBUDetails,
    //   //   nfa_cat_vset: null,
    //   //   nfa_cat: null,
    //   //   nfa_sub_cat_vset: null,
    //   //   nfa_sub_cat: null
    //   // };
    //   // this.showHideHistory(true, 'uploadDocument');
    // },
    addNewRow() {
        if (this.editMode) {
          this.mapBUData.push({
            add_site_bu_id: 0,
            bu_name: null,
            expense_type: null,
            active: true,
            nature_of_supply: null,
            tds_section: null
          });
        }
      },
    removeRow(index) {
        if (this.editMode) {
          this.mapBUData.splice(index, 1);
        }
    },
    editModeChange() {
        this.editMode = true;
    },
    mapSelectedVsetData(item) {
      if (this.modalType === 'business_unit') {
        this.mapBUData[this.specIndex].bu_name = item.lookup_code;
      } else if (this.modalType === 'expense_type') {
        this.mapBUData[this.specIndex].expense_type = item.lookup_code;
      }
      this.mapBUData = JSON.parse(
        JSON.stringify(this.mapBUData)
      );
      this.showHideCommonModal(false);
    },
    showHideCommonModal(flag, type, index) {
      this.modalType = type;
      this.specIndex = index;
      this.showCommonModal = flag;
    },
    clearVsetValues(vsetCode, index) {
      switch (vsetCode) {
        case 'business_unit':
          this.mapBUData[index].bu_name = null;
          break;
        case 'expense_type':
          this.mapBUData[index].expense_type = null;
          break;
        case 'NATURE_OF_SUPPLY':
         this.mapBUData[index].nature_of_supply = null;
         break;
        case 'TDS_SECTION_ACTUAL':
          this.mapBUData[index].tds_section = null;
          break;
      }
    },
    getMapBUDataById() {
        const payload = {
          add_site_id: this.rowData ? this.rowData.add_site_id : this.wfBUDetails ? this.wfBUDetails.add_site_id : null,
          add_site_bu_id: this.wfBUDetails ? this.wfBUDetails.add_site_bu_id : null,
          type: this.wfBUDetails ? 'Workflow' : ''
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/getMapBUDataById', payload)
          .then(resp => {
            this.loader = false;
            if (resp.status === 200) {
              const result = resp.data.data[0];
              this.wfApprovalStatus = result.approval_status_key;
              this.approvalStatusKey = result.approval_status_key;
              this.mapBUData = resp.data.data
                if(this.mapBUData.length==0){
                  this.mapBUData= [
                    {
                        bu_name:null,
                        expense_type: null,
                        active:true,
                        add_site_bu_id: null,
                        nature_of_supply: null,
                        tds_section: null
                    }
                  ]
                }
                
                // this.mapBUData.push({
                //   add_site_bu_id: null,
                //   bu_name: null,
                //   expense_type: null,
                //   active: true
                // });
            }
          })
          .catch(() => {
            this.loader = false;
          });
    },
    checkUncheckAll() {
      this.mapBUData = this.mapBUData.map(data => {
        data.acc_flag = this.selectAllCheckBox;
        return data;
      });
    },
    addEditMapBUDetails() {
    //   const filterData = this.mapBUData.filter(data => data.acc_flag);
    //   if (filterData.length) {
        const partyDetails = this.mapBUData.map(elem => {
          return {
            add_site_bu_id: elem.add_site_bu_id ? elem.add_site_bu_id : 0,
            ou_name: this.rowData.ou_name,
            ou_id: this.rowData.ou_id,
            bu_id: elem.bu_id,
            bu_name: elem.bu_name,
            expense_type: elem.expense_type,
            active: elem.active,
            // nature_of_supply: elem.nature_of_supply,
            // tds_section: elem.tds_section
          };
        });
        const payload = {
          add_site_id_dtls: partyDetails ? partyDetails : null,
          add_site_id: this.rowData.add_site_id
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/addEditMapBUDetails', payload)
          .then(response => {
            this.loader = false;
            this.showAlert = true;
            if (response.status === 201) {
              this.editMode = false;
              this.isSuccess = true;
              this.responseMsg = response.data.message;
              this.isAccDetailsSaved = true;
              this.getMapBUDataById();
              // if (value === 'finance') {
              //   this.validateAccountType();
              // }
              // this.clearFields();
            } else {
              this.isSuccess = false;
              this.responseMsg = response.response.data.message;
            }
          })
          .catch(() => {
            this.loader = false;
            this.isSuccess = false;
            this.responseMsg = appStrings.autoFailedMsg;
          });
    //   } else {
    //     alert('Please Select Accounting Details');
    //   }
    },
    getBusinessUnitDetail() {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getBusinessUnitDetail')
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            const getValueAndText = result.map(type => {
              return {
                value: type.lookup_code,
                text: type.lookup_code
              };
            });
            this.businessList = getValueAndText;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getExpenseTypeDetail() {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getExpenseTypeDetail')
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            const getValueAndText = result.map(type => {
              return {
                value: type.lookup_code,
                text: type.lookup_code
              };
            });
            this.expenseList = getValueAndText;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHidePartyDetailsModal(flag) {
      this.showPartyDetailsModal = flag;
    },
    updateKey() {
      this.updatedObject = { ...this.rowData };
       if (this.updatedObject.hasOwnProperty('party_req_id')) {
       this.updatedObject.req_id = this.updatedObject.party_req_id;
       delete this.updatedObject.party_req_id;
       this.dataobj= this.updatedObject;
     }
   },
   openValueSetModal(vsetCode, index) {
     this.vsetCode = vsetCode;
     this.specIndex = index;
     this.showValueSetModal = true;
     this.parent_value_set_id = null;
     this.setTimeVsetCode = setTimeout(() => {
       const vSetData = {
         valueSetName: vsetCode,
         multiFlag: null
       };
       this.eventBus.$emit('valueSetCode', vSetData);
     }, 0);
   },
   selectedvalueSet(item) {
     if (this.vsetCode === 'NATURE_OF_SUPPLY') {
       this.mapBUData[this.specIndex].nature_of_supply = item.value_code;
       this.tdsSectionValue();
      //  this.mapBUData[this.specIndex].nature_of_supply = item.tax_group;
     } else  if (this.vsetCode === 'TDS_SECTION_ACTUAL') {
      this.mapBUData[this.specIndex].tds_section = item.value_code;
    } 
    //  else if (
    //    this.vsetCode === appStrings.VALUESETTYPE.TAX_CATEGORY_NAME_VSET
    //  ) {
    //    if (this.taxNature === 'investor_intra') {
    //      this.gridData[this.specIndex].investor_intra_tax_cat_name =
    //        item.category_name;
    //      this.gridData[this.specIndex].investor_intra_tax_cat =
    //        item.tax_cat_hdr_id;
    //    } else if (this.taxNature === 'investor_inter') {
    //      this.gridData[this.specIndex].investor_inter_tax_cat_name =
    //        item.category_name;
    //      this.gridData[this.specIndex].investor_inter_tax_cat =
    //        item.tax_cat_hdr_id;
    //    } else {
    //      this.gridData[this.specIndex].category_name = item.category_name;
    //      this.gridData[this.specIndex].tax_cat_id = item.tax_cat_hdr_id;
    //    }
    //  }
     this.showValueSetModal = false;
   },
   tdsSectionValue(){
    if(this.mapBUData[this.specIndex].nature_of_supply === 'GOODS' && this.rowData.pan_no && this.rowData.country === 'India'){
      this.mapBUData[this.specIndex].tds_section = 'TDS Section 194Q-IND'
    } else if(this.mapBUData[this.specIndex].nature_of_supply === 'GOODS' && this.rowData.pan_no === 'PANNOTAVAILABLE' && this.rowData.country === 'India'){
      this.mapBUData[this.specIndex].tds_section = 'TDS Section 194QP-IND'
    } else if(this.mapBUData[this.specIndex].nature_of_supply === 'GOODS' && this.rowData.country !== 'India'){
      this.mapBUData[this.specIndex].tds_section = 'TDS Not Applicable'
    } 
    // else if(this.mapBUData[this.specIndex].nature_of_supply === 'SERVICES' && this.rowData.country === 'India'){
    //   this.openValueSetModal();
    // } 
    else if(this.mapBUData[this.specIndex].nature_of_supply === 'SERVICES' && this.rowData.country !== 'India'){
      // this.valueData='SERVICES'
      this.mapBUData[this.specIndex].tds_section = 'TDS Section 195A'
    } 
   }
  },
  beforeDestroy() {
  }
};
